import React from 'react';
import HeroSectionHealthcare from '../components/HeroSectionHealthcare';
import LogoSection from '../components/LogoSection';
import StatsSectionHealthcare from '../components/StatsSectionHealthcare';
import TaleOfTwoOwnersSection from '../components/TaleOfTwoOwnersSection';
import TeamSection from '../components/TeamSection';
import TimelineSection from '../components/TimelineSection';
import FAQSection from '../components/FAQSection';
const HealthcareClinicsPage = () => {
  return <main className="flex-grow" data-id="element-411">
      <HeroSectionHealthcare data-id="element-412" />
      <LogoSection data-id="element-413" />
      <StatsSectionHealthcare data-id="element-414" />
      <TaleOfTwoOwnersSection data-id="element-415" />
      <TeamSection data-id="element-416" />
      <TimelineSection data-id="element-417" />
      <FAQSection data-id="element-418" />
    </main>;
};
export default HealthcareClinicsPage;